
class processW{
      constructor(  
            id,
            name,
            description,
            type,
            concept
            ) {
    
      
      this.id = id
      this.name = name
      this.description= description
      this.type =type
      this.concept = concept
      
      }
      static fromJson({ 
            procesoId,
            nombre,
            descripcion,
            tipo,
            conceptoId
}) {
        return new processW(
            procesoId,
            nombre,
            descripcion,
            tipo,
            conceptoId);
      }
    }
    export default processW